import style from "../../pentestWindows.module.css";

import { PentestContext, WindowType } from "../../../../contexts/PentestContext";
import {
  FileTerminal,
  LayoutTemplate,
  Maximize2,
  Minimize2,
  NotebookPen,
  Settings,
  Users,
} from "lucide-react";
import { useContext } from "react";
import { AppContext } from "../../../../contexts/AppContext";
import { TutorialContext } from "../../../../contexts/TutorialContext";
import Tooltip from "../../../Common/Tooltips/Tooltip/Tooltip";

interface Props {
  setMetadataModal: (value: boolean) => void;

  maximize: boolean;
  setMaximize: (value: boolean) => void;
}

function Sidebar({ setMetadataModal, maximize, setMaximize }: Readonly<Props>) {
  const { tutorial } = useContext(AppContext);
  const { currentWindow, setCurrentWindow } = useContext(PentestContext);

  const { tutorialRefs, nextStep } = useContext(TutorialContext);

  function getHighlight(selectedWindow: WindowType) {
    if (currentWindow === selectedWindow) return style.highlightedTab;
    return "";
  }
  const largeSidebar = maximize ? style.windowPickerLarge : "";

  return (
    <div
      className={style.windowPicker + " " + largeSidebar}
      ref={tutorialRefs.sidebarRef}
    >
      <div className={style.topTab}>
        <Tooltip
          trigger={
            <button
              className={style.tab}
              onClick={() => {
                setMaximize(!maximize);
              }}
            >
              {maximize ? (
                <Minimize2 className={style.tabIcon} strokeWidth="1.5" />
              ) : (
                <Maximize2 className={style.tabIcon} strokeWidth="1.5" />
              )}
            </button>
          }
          description={!maximize ? "Maximize" : "Minimize"}
          showArrow
          sidebar
        />
      </div>
      <Tooltip
        trigger={
          <button
            className={style.tab + " " + getHighlight("logger")}
            onClick={() => {
              setCurrentWindow("logger");
            }}
          >
            <FileTerminal className={style.tabIcon} strokeWidth="1.5" />
            <span className={style.textStyle}>CLI Monitor</span>
          </button>
        }
        description="CLI Monitor"
        showArrow
        sidebar
      />
      <Tooltip
        trigger={
          <button
            ref={tutorialRefs.editorButtonRef}
            className={style.tab + " " + getHighlight("editor")}
            onClick={() => {
              setCurrentWindow("editor");
              if (tutorial) nextStep();
            }}
          >
            <NotebookPen className={style.tabIcon} strokeWidth="1.5" />
            <span className={style.textStyle}>Editor</span>
          </button>
        }
        description="Editor"
        showArrow
        sidebar
      />
      <Tooltip
        trigger={
          <button
            ref={tutorialRefs.exportPdfRef}
            className={style.tab + " " + getHighlight("template")}
            onClick={() => {
              setCurrentWindow("template");
            }}
          >
            <LayoutTemplate className={style.tabIcon} strokeWidth="1.5" />
            <span className={style.textStyle}>Template</span>
          </button>
        }
        description="Template"
        showArrow
        sidebar
      />

      <div className={style.grayLine} />

      <Tooltip
        trigger={
          <button className={style.tab} onClick={() => setCurrentWindow("collaboration")}>
            <Users className={style.tabIcon} strokeWidth="1.5" />
            <span className={style.textStyle}>Team</span>
          </button>
        }
        description="Team"
        showArrow
        sidebar
      />

      <Tooltip
        trigger={
          <button className={style.tab} onClick={() => setMetadataModal(true)}>
            <Settings className={style.tabIcon} strokeWidth="1.5" />
            <span className={style.textStyle}>Metadata</span>
          </button>
        }
        description="Metadata"
        showArrow
        sidebar
      />
    </div>
  );
}

export default Sidebar;
